import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, defaultProps, withState, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';

import { getUser } from '../../../../redux/actions';
import { CREATE } from '../graphql/index';
import CreateAccountCard from '../../components/createAccountCard/CreateAccountCard';


const mapDispatchtoProps = (dispatch) => {
  return {
    getUser: (newUser) => {
      const user = {
        email: newUser.email,
        name: newUser.name,
        token: newUser.token,
      };
      dispatch(getUser(user));
    },
  };
};

/* eslint-disable react/prop-types */
const withData = (props) => {
  const createAccount = (name, email, password, confirmation) => {
    if (!props.loading) {
      props.toggleLoading();    // toggle loading
      props.toggleError(false); // disable error message
      props.mutate({ variables: { name, email, password, confirmation } }).then(({ data }) => {
        props.toggleLoading();                             // toggle loading
        localStorage.token = data.createAccount.token;     // update localStorage
        localStorage.userName = data.createAccount.name;   // update localStorage
        localStorage.userEmail = data.createAccount.email; // update localStorage
        props.getUser(data.createAccount);                 // update store
        props.router.push('/dashboard');                   // change route
      }).catch((error) => {
        const type = error.message.substring('GraphQL error: '.length).substring(0, 3);
        switch (type) {
          case '422':
            props.updateErrorMessage('Este email já foi usado.');
            props.toggleError(true);
            break;
          default:
            props.toggleError(true);
            props.updateErrorMessage('');
            console.log(error); // eslint-disable-line no-console
        }
        props.toggleLoading();
      });
    }
  };
  return (
    <CreateAccountCard
      createAccount={createAccount}
      {...props}
    />
  );
};

const errorMessages = {
  nameNotValid: 'O campo nome é obrigatório',
  emailNotValid: 'O email não é válido',
  passwordNotValid: 'A senha deve ter 6 caracteres ou mais',
  passwordsNotEqual: 'As senhas não conferem',
};

const enhance = compose(
  defaultProps({
    title: 'Nova conta',
    nameLabel: 'Nome',
    emailLabel: 'Email',
    passwordLabel: 'Senha',
    confirmPasswordLabel: 'Confirme a nova senha',
    buttonLabel: 'OK',
    backLabel: 'Voltar',
    backLink: '#',
    message: 'A nova conta foi criada com sucesso.',
    callToAction: 'Continuar',
    callToActionLink: '#',
    errorIcon: 'ban',
    errorTitle: 'Erro',
    errorMessages,
  }),
  withState('loading', 'toggleLoading', false),
  withState('error', 'toggleError', false),
  withState('errorMessage', 'updateErrorMessage', ''),
  withHandlers(
    {
      toggleLoading: props => () => {
        props.toggleLoading(!props.loading);
      },
      toggleError: props => (hasError) => {
        props.toggleError(hasError);
      },
      updateErrorMessage: props => (message) => {
        props.updateErrorMessage(message);
      },
    },
  ),
);

const CreateAccountContainer = enhance(injectIntl(withRouter(connect(null, mapDispatchtoProps)(withData))));

export default graphql(CREATE)(CreateAccountContainer);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/apollo/containers/CreateAccountContainer.js
 **/